module.exports = __webpack_public_path__ + "media/images/cake-0e1cbf96eb59f686152309b20eafde27.svg";